import { render, staticRenderFns } from "./orderSettlementyewu.vue?vue&type=template&id=6133b434&"
import script from "./orderSettlementyewu.vue?vue&type=script&lang=js&"
export * from "./orderSettlementyewu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports